import React from 'react';
import { DATA_SCALE_HANDLE } from '../../constants';

/**
 * @param {Object[]} scores - scores
 * @param {string} scores[].handle - scale handle
 *
 * @returns {Object} - modal hooks
 */
export function useSingleScaleModal(scores) {
    const [visibleScaleHandle, setVisibleScaleHandle] = React.useState(null);
    const isOpen = !!visibleScaleHandle;

    const visibleScaleIndex = scores.findIndex(
        score => score?.handle === visibleScaleHandle
    );
    const canGoBack = visibleScaleIndex > 0;
    const canGoNext = visibleScaleIndex < scores.length - 1;

    const onOpen = evt => {
        const scaleHandle = evt?.currentTarget?.getAttribute?.(DATA_SCALE_HANDLE);

        if (!scaleHandle) {
            return;
        }

        setVisibleScaleHandle(scaleHandle);
    };
    const onClose = () => {
        setVisibleScaleHandle(null);
    };

    const goNext = () => {
        if (!canGoNext) {
            return;
        }

        const nextScaleHandle = scores[visibleScaleIndex + 1]?.handle;

        setVisibleScaleHandle(nextScaleHandle);
    };
    const goBack = () => {
        if (!canGoBack) {
            return;
        }

        const previousScaleHandle = scores[visibleScaleIndex - 1]?.handle;

        setVisibleScaleHandle(previousScaleHandle);
    };

    return {
        visibleScaleHandle,
        visibleScaleIndex,
        isOpen,
        onOpen,
        onClose,
        goNext,
        goBack,
        canGoNext,
        canGoBack
    };
}
